/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import i18n from 'i18next';

import {
  getRestrictedAdminUsersAndGroupsSearch,
  ExceedGroupsCustomListItem,
  ExceedGroupsCustomMenu,
} from '@/exceed';

export default ({ onClick, orgId }) => {
  const GroupsCustomListItem = (props) => (
    <ExceedGroupsCustomListItem
      {...props}
      onClick={onClick}
      isClickable
      buttonAriaLabel={i18n.t('remove-editor-permissions')}
    />
  );

  return {
    title: i18n.t('editor-permissions-label'),
    body: i18n.t('editor-permissions-body'),
    schema: {
      accessible_by: {
        type: 'AutoCompleteSearch',
        label: i18n.t('permissions-label'),
        handleLoadOptions: (searchValue) =>
          getRestrictedAdminUsersAndGroupsSearch({ searchValue, organizationId: orgId }),
        CustomSelectedOptionItem: GroupsCustomListItem,
        emptyStateText: i18n.t('permissions-empty-state'),
        selectProps: {
          placeholder: i18n.t('add-groups-or-users'),
          components: { Option: ExceedGroupsCustomMenu },
        },
      },
    },
  };
};
